import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

// ------------------------------------------------------------------------------------------

function RedirectToWF() 
{

  React.useEffect( () => { 
    setTimeout( () => window.location.href = "https://www.workingfeedback.co.uk", 1000 );
  }, []);

  return (
    <Box sx={{ width: '100%', height: '100%', flex: 1, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', display: 'fex' }}>
        <CircularProgress color="primaryNavy" />
    </Box>
  );
  
}

export default RedirectToWF;